import { cloneElement, ReactElement, SVGProps } from 'react';

import { useDynamicSvgIcon } from '@gn-audio/jss-components';

import TableCell from './TableCell';
import { IconCellFields } from './tableSpotTypes';

type IconCellProps = {
  cell: IconCellFields;
  background: string;
};

const IconCell = ({ cell: { icon, label }, ...rest }: IconCellProps) => {
  const { svgElement } = useDynamicSvgIcon(icon?.value, 'none');

  return (
    <TableCell {...rest}>
      <>
        {svgElement &&
          cloneElement(svgElement as ReactElement<SVGProps<SVGSVGElement>>, {
            ...(svgElement.props || {}),
            className: 'size-9',
            viewBox: '0 0 24 24',
          })}
        <div className="font-bold md:ml-[0.625rem]">
          <span className="sr-only md:not-sr-only">{label?.value}</span>
        </div>
      </>
    </TableCell>
  );
};

export default IconCell;
